import { IntlProviderWithMessages, useLocale } from '@databases/intl';
import React, { useEffect, useState } from 'react';

import App from './standalone-app';

const AppWithBridgeData = () => {
  const locale = useLocale();
  const [bridgeData, setBridgeData] = useState(
    window.frameElement?.getAttribute('data-bridge-data')
  );
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          setBridgeData(window.frameElement?.getAttribute('data-bridge-data'));
        }
      });
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    observer.observe(window.frameElement!, {
      attributes: true,
      attributeFilter: ['data-bridge-data'],
    });
    return () => {
      observer.disconnect();
    };
  }, []);
  if (!bridgeData) {
    return null;
  }

  return (
    <IntlProviderWithMessages locale={locale}>
      <App config={JSON.parse(bridgeData)} />
    </IntlProviderWithMessages>
  );
};

export default AppWithBridgeData;
